import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { UtilitiesService } from '../services/utilities.service';

@Injectable({
  providedIn: 'root'
})
export class UserDataGuard implements CanActivate {
  udata: any = null;
  constructor(private utilitiesService: UtilitiesService) {
    
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if (this.udata) {
        this.udata = this.utilitiesService.getUserData();
        this.utilitiesService.getAndStoreData(this.udata.id).then(res =>{
        console.log('Update Local Storage User');
        });
      }
    return true;
  }
  
}
